import React from 'react';
import { Grid, TextField, Box } from '@mui/material';
import { useFormik } from "formik";
import * as yup from "yup";
import styles from './patient.module.scss'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from 'react';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { labAddDropdown } from '../../../Pages/Lab/LabServices';
import { CMLabel } from '../../../components/common/Form/FormLabels';
import { CMAutoComplete } from '../../../components/common/AutoComplete/AutoComplete';
import { buttonStyle } from '../../../components/common/Helpers/InlineStyles';
import { CMButton } from '../../../components/common/Button/Button';
import { emailRegex, floatingRegex, nameRegex, numberRegex, numberandspecialcharacterRegex, phoneRegex, wordToWordSpaceRegex } from '../../../components/common/Helpers/Validations';


function PatientModel(props: any) {
    const ModelBodyComponent = props.modelCmpnt;
    const currentDate = dayjs().format('YYYY-MM-DD');

    const currentDate1 = dayjs();
    const futureDate = currentDate1.add(30, 'day');
    const futureDateFormatted = futureDate.format('YYYY-MM-DD');


    const handleChange = (fields: any, e: any) => {
        formik.setFieldValue(fields, e.target.value);
    }
    const handleDateChange = (fields: any, e: any) => {
        const date = dayjs(e['$d']).format('YYYY-MM-DD')
        formik.setFieldValue(fields, date)
    }
    const [test, setTest] = useState<any>([])
    const handleDropdownChange = (fields: any, e: any) => {
        formik.setFieldValue(fields, e.id)
    }
    useEffect(() => {
        labAddDropdown().then((res: any) => {
            setTest(res)
        })

    }, [])
    const formik: any = useFormik({
        initialValues: {
            id: props?.rowData?.id ? props?.rowData?.id : "",
            weight: props?.rowData?.weight ? props?.rowData?.weight : "",
            bp: props?.rowData?.bp ? props?.rowData?.bp : '',
            fever: props?.rowData?.fever ? props?.rowData?.fever : '',
            sp02: props?.rowData?.sp02 ? props?.rowData?.sp02 : '',
            first_visit: props?.rowData?.first_visit ? props?.rowData?.first_visit : currentDate,
            revisit: props?.rowData?.revisit ? props?.rowData?.revisit : futureDateFormatted,
            amount: props?.rowData ?.amount? props?.rowData.amount : "",
            payment_date: props?.rowData ?.payment_date? props?.rowData.payment_date : currentDate,
            reason: props?.rowData ?.reason? props?.rowData.reason : "",
        },
        validationSchema: yup.object({
            weight: yup.string().ensure().required("Weight is required!").matches(floatingRegex,{message:"please enter only Numbers!"}),
            bp: yup.string().ensure().matches(numberandspecialcharacterRegex,{message:"please enter only Numbers & Special Characters!"}),
            fever: yup.string().ensure().required("Fever is required!").matches(floatingRegex,{message:'Enter Only Numbers!',}),
            sp02: yup.string().ensure().required(" SP02 is required!").matches(floatingRegex,{message:"Enter Only Numbers!"}),
            first_visit: yup.string().required(" First Visit is required!"),
            revisit: yup.string().required(" Revisit is required!"),
            amount: yup.string().required(" Amount is required!").matches(numberRegex,{message:"Enter Only Numbers!"}),
            payment_date: yup.string().required(" Paymnet Date is required!"),
            reason: yup.string().ensure().required(" Reason is required!").min(3, 'To short!'),

        }),
        onSubmit: (values: any) => {

            if (props?.rowData) {
                console.log(values, "values");
                let totalvalues: any = { ...values }
                props.edit(totalvalues)
            } else {
                let totalvalues: any = { ...values }
                props.onAddRow(totalvalues);
            }
            props?.onHide();
            localStorage.removeItem('patient');
        },
    });

    return (
        <>
            {props?.show &&
                <Modal isOpen={props?.show} onHide={props?.onHide} >
                    <ModalHeader toggle={props.onHide}><h5><b>{props.header}</b></h5></ModalHeader>
                    <ModalBody>
                        <form onSubmit={formik.handleSubmit}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <CMLabel>Weight</CMLabel>
                                    <TextField
                                        placeholder='Enter Weight '
                                        size="small"
                                        name="weight"
                                        fullWidth
                                        onChange={(e: any) => handleChange("weight", e)}
                                        value={formik.values?.weight}
                                    />
                                    {formik.touched.weight && formik.errors.weight && (
                                        <div className={styles.laberrortext + " text-danger"}>{formik.errors.weight}</div>)
                                    }
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <CMLabel>Blood Pressure(BP)</CMLabel>
                                    <TextField
                                        placeholder='Enter Blood Pressure '
                                        size="small"
                                        name="bp"
                                        fullWidth
                                        onChange={(e: any) => handleChange("bp", e)}
                                        value={formik.values?.bp}
                                    />
                                    {formik.touched.bp && formik.errors.bp && (
                                        <div className={styles.laberrortext + " text-danger"}>{formik.errors.bp}</div>)
                                    }
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <CMLabel>Fever</CMLabel>
                                    <TextField
                                        placeholder='Enter Fever '
                                        size="small"
                                        name="fever"
                                        fullWidth
                                        onChange={(e: any) => handleChange("fever", e)}
                                        value={formik.values?.fever}
                                    />
                                    {formik.touched.fever && formik.errors.fever && (
                                        <div className={styles.laberrortext + " text-danger"}>{formik.errors.fever}</div>)
                                    }
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <CMLabel>SPO2</CMLabel>
                                    <TextField
                                        placeholder='Enter SPO2 '
                                        size="small"
                                        name="sp02"
                                        fullWidth
                                        onChange={(e: any) => handleChange("sp02", e)}
                                        value={formik.values?.sp02}
                                    />
                                    {formik.touched.sp02 && formik.errors.sp02 && (
                                        <div className={styles.laberrortext + " text-danger"}>{formik.errors.sp02}</div>)
                                    }
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <CMLabel>First Visit</CMLabel>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            slotProps={{ textField: { fullWidth: true, size: 'small', name: 'first_visit' } }}
                                            format="YYYY-MM-DD"
                                            value={dayjs(formik.values?.first_visit)}
                                            onChange={(val: any) => handleDateChange('first_visit', val)} />
                                    </LocalizationProvider>
                                    {formik.touched.first_visit && formik.errors.first_visit && (
                                        <div className={styles.laberrortext + " text-danger"}>{formik.errors.first_visit}</div>)
                                    }
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <CMLabel>Revisit Date</CMLabel>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            slotProps={{ textField: { fullWidth: true, size: 'small', name: 'revisit' } }}
                                            format="YYYY-MM-DD"
                                            value={dayjs(formik.values?.revisit)}
                                            onChange={(val: any) => handleDateChange('revisit', val)} />
                                    </LocalizationProvider>
                                    {formik.touched.revisit && formik.errors.revisit && (
                                        <div className={styles.laberrortext + " text-danger"}>{formik.errors.revisit}</div>)
                                    }
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <CMLabel>Amount</CMLabel>
                                    <TextField
                                        placeholder='Enter Amount '
                                        size="small"
                                        name="amount"
                                        fullWidth
                                        onChange={(e: any) => handleChange("amount", e)}
                                        value={formik.values?.amount}
                                    />
                                    {formik.touched.amount && formik.errors.amount && (
                                        <div className={styles.laberrortext + " text-danger"}>{formik.errors.amount}</div>)
                                    }
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <CMLabel>Payment Date</CMLabel>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            slotProps={{ textField: { fullWidth: true, size: 'small', name: 'payment_date' } }}
                                            format="YYYY-MM-DD"
                                            value={dayjs(formik.values?.payment_date)}
                                            onChange={(val: any) => handleDateChange('payment_date', val)} />
                                    </LocalizationProvider>
                                    {formik.touched.payment_date && formik.errors.payment_date && (
                                        <div className={styles.laberrortext + " text-danger"}>{formik.errors.payment_date}</div>)
                                    }
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <CMLabel>Reason</CMLabel>
                                    <TextField
                                        placeholder='Enter Reason'
                                        size="small"
                                        name="reason"
                                        multiline
                                        minRows={3}
                                        fullWidth
                                        onChange={(e: any) => handleChange("reason", e)}
                                        value={formik.values.reason}
                                    />
                                    {formik.touched.reason && formik.errors.reason && (
                                        <div className={styles.laberrortext + " text-danger"}>{formik.errors.reason}</div>)
                                    }
                                </Grid>
                            </Grid>
                            <Box component='div'
                                sx={buttonStyle}>
                                <Box component='span'>
                                    <CMButton variant="contained" value="Submit" type="submit" color="primary" />
                                </Box>
                            </Box>
                        </form>
                    </ModalBody>
                </Modal>
            }
        </>
    );
}

export default PatientModel;